/**
 * Gallery.
 *
 * @description A child gallery component for the Inauguration 2024 theme.
 * @author Tim Spears
 * @see https://splidejs.com/guides/
 */

import '@splidejs/splide/css/core'
import '@splidejs/splide-extension-video/dist/css/splide-extension-video.min.css';

import Splide from '@splidejs/splide'
import { Video } from '@splidejs/splide-extension-video';

const mainSliderOptions = {
	arrows       : false,
	easing       : 'cubic-bezier(0.22, 1, 0.36, 1)',
	flickPower   : 300,
	pagination   : false,
	type         : 'loop',
    flickMaxPages: 1,
    speed        : 1200,
    updateOnMove : true,
	video: {
		disableOverlayUI: true,
	}
}

const thumbnailSliderOptions = {
	arrows: {
		prev  : 'splide__arrow--prev gallery__thumbnails-arrow--prev',
		next  : 'splide__arrow--next gallery__thumbnails-arrow--next',
	},
	dragMinThreshold: {
		mouse: 4,
		touch: 10,
	},
	easing          : 'cubic-bezier(0.22, 1, 0.36, 1)',
	fixedWidth      : '8vi',
	flickMaxPages   : 1,
	flickPower      : 300,
	focus           : 'center',
	focus           : 'center',
	gap             : 'max(1vi, var(--size-0))',
	isNavigation    : true,
	pagination      : false,
	rewind          : true,
	speed           : 1200,
	trimSpace       : false,
	updateOnMove    : true,
}

export class Gallery {
	constructor(el) {
		this.beforeSetup()
		this.el = el
		this.slug = el.dataset.gallery
		this.mainSliderElement = el.querySelector('[data-gallery-main]')
		this.thumbnailSliderElement = el.querySelector('[data-gallery-thumbnails]')
		this.mainSlider = null
		this.thumbnailSlider = null

		this.setup()

		this.afterSetup()

		this.beforeInit()
		this.init()
		this.afterInit()
	}

	buildMainSlider() {
		if (!this.mainSliderElement) { return }
		return this.mainSlider = new Splide(this.mainSliderElement, mainSliderOptions)
	}

	buildThumbnailSlider() {
		if (!this.thumbnailSliderElement) { return }
		return this.thumbnailSlider = new Splide(this.thumbnailSliderElement, thumbnailSliderOptions)
	}

	buildEventListeners() {
		this.mainSlider.on('video:pause', (active) => {
			active.Splide.root.classList.add('is-paused')
		})
		this.mainSlider.on('video:play', (active) => {
			active.Splide.root.classList.remove('is-paused')
		})
		this.mainSlider.on('move', () => {
			this.mainSlider.root.classList.remove('is-paused')
		})
	}

	setup() {
		this.buildMainSlider()
		this.buildThumbnailSlider()
		this.buildEventListeners()
	}

	init() {
		this.mainSlider.sync( this.thumbnailSlider )
		this.mainSlider.mount({ Video })
		this.thumbnailSlider.mount()
	}

	beforeSetup() {}
	afterSetup() {}
	beforeInit() {}
	afterInit() {}
}
